'use client';

import { useEffect, useState } from 'react';

import { BREAKPOINTS } from '@/constants/breakpoints';

export default function useDeviceType() {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const updateDeviceType = () => {
      const width = document.documentElement.clientWidth;
      setIsMobile(width < BREAKPOINTS.Tablet);
      setIsTablet(width >= BREAKPOINTS.Tablet && width < BREAKPOINTS.Desktop);
      setIsDesktop(width >= BREAKPOINTS.Desktop);
    };

    updateDeviceType();
    window.addEventListener('resize', updateDeviceType);

    return () => {
      window.removeEventListener('resize', updateDeviceType);
    };
  }, []);

  return { isMobile, isTablet, isDesktop };
}
